import { EImageType } from '../../types/offer';
import { IOfferDesktop } from '../../repositories/offers-comparison/entities/offer/OfferDesktop';

export function transformComparisonImages({ images }: IOfferDesktop) {
  return images.map(image => ({
    ...image,
    type: image.type as unknown as EImageType,
  }));
}
